// import store from '../../store/index.js'
import { getInfo } from './auth.js'
import { paramsview } from './params.js'
// export const baseUrl = 'http://112.74.74.249:4001'
import request from '../../plugins/request'
// const baseUrl = 'http://novel.atxg.world:4001'
export default function eventRequest(options){
	let data = paramsview
	//添加用户信息
	if(getInfo() != '' && getInfo() != null){
		data.userId = getInfo().id.toString() || ''
	}
	// data.phone = store.userInfo.phone || ''
	let params = Object.assign(data,options)
	params.userId = params.userId.toString()
	// console.log("事件。。。。")
	// console.log(params) 
	
	// uni.request({
	// 	url: baseUrl + '/api/Event/AddEventInfo',
	// 	method:'POST',	
	// 	data: {data:params || {}},
	// 	header: options.header || {'Content-Type':'application/json;charset=UTF-8;'},
	// 	dataType: 'json',
	// }).then((response) => {
	// 	// console.log(response)
	// }).catch(error => {
	// 	// let [err, res] = error;
	// })
	
	return request({
	  url: '/api/AuthorEvent/AddAuthorEvent',
	  method: 'post',
	  data: {data:params || {}},
	  baseURL: `${process.env.VUE_APP_BASE_API}`
	})
}